import {
  MODAL_SHOW,
  MODAL_HIDE,
  LOADING_SHOW,
  LOADING_HIDE,
  FLASH_MESSAGE_SET,
} from '../../constants/actionTypes';

const INITIAL_STATE = {
  modal: {
    isVisible: false,
    currentTarget: '',
  },
  loading: {
    isVisible: false,
  },
  flashMessage: {
    type: null,
    content: {
      title: '',
      text: '',
    },
  },
};

const applyShowModal = (state, action) => ({
  ...state,
  modal: {
    isVisible: true,
    currentTarget: action.target,
  },
});

const applyHideModal = state => ({
  ...state,
  modal: {
    isVisible: false,
    currentTarget: '',
  },
  flashMessage: {
    type: INITIAL_STATE.type,
    content: INITIAL_STATE.content,
  },
});

const applyShowLoading = state => ({
  ...state,
  loading: {
    isVisible: true,
  },
});

const applyHideLoading = state => ({
  ...state,
  loading: {
    isVisible: false,
  },
});

const applySetFlashMessage = (state, action) => ({
  ...state,
  flashMessage: action.payload,
});

const uiReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_SHOW:
      return applyShowModal(state, action);
    case MODAL_HIDE:
      return applyHideModal(state);
    case LOADING_SHOW:
      return applyShowLoading(state);
    case LOADING_HIDE:
      return applyHideLoading(state);
    case FLASH_MESSAGE_SET:
      return applySetFlashMessage(state, action);
    default:
      return state;
  }
};

export default uiReducer;
